'use client'

import { forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

import { cn } from '@src/utils/tailwind'

type InputProps = React.InputHTMLAttributes<HTMLInputElement>

export const Checkbox = forwardRef<HTMLInputElement, InputProps>(
  ({ className, id, children, ...props }, ref) => {
    return (
      <label className={twMerge('inline-flex cursor-pointer items-start', className)} htmlFor={id}>
        <div className="-mt-1.5 -mr-2 flex h-10 min-w-[40px] items-center justify-center rounded-full hover:bg-bodi-gray-pearl">
          <input
            type="checkbox"
            className={cn(
              `
            size-5 cursor-pointer rounded
            border-2 border-bodi-gray-butters
            text-bodi-green-deep-500
            ring-0

            ring-transparent outline outline-0 outline-offset-2
            outline-transparent checked:border-bodi-green-deep-500

            checked:bg-bodi-input-selected
            checked:hover:border-bodi-green-deep-500
            checked:hover:bg-bodi-input-selected
            focus:ring-0

            focus:ring-transparent
            checked:focus:border-bodi-green-deep-500

            checked:focus:bg-bodi-input-selected
            focus-visible:outline-2

            focus-visible:outline-bodi-black-text
            `,
              {
                'bg-bodi-gray-light': props.disabled,
              }
            )}
            ref={ref}
            {...props}
            id={id}
          />
        </div>
        <div
          className={cn('z-10 pl-3 text-body-sm', { 'text-bodi-gray-disabled': props.disabled })}
        >
          {children}
        </div>
      </label>
    )
  }
)

Checkbox.displayName = 'Checkbox'
